$('.schedule-exception-rules-container').on('cocoon:after-insert', function(
  e,
  insertedElement
) {
  require.ensure('../forms/hints', function(require) {
    var hints = require('../forms/hints');
    hints(insertedElement);
  });
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/hints.initializer.js